import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=71a4fb9a"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&id=71a4fb9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports